import script from "./shop.vue?vue&type=script&setup=true&lang=js"
export * from "./shop.vue?vue&type=script&setup=true&lang=js"

import "./shop.vue?vue&type=style&index=0&id=703ca542&lang=less&scoped=true"

import exportComponent from "../../../node_modules/_vue-loader@17.4.2@vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-703ca542"]])

export default __exports__